import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Button } from "react-bootstrap";
import { actions } from "react-redux-form";
import { isObjectEqual, areDataEqual } from "../../../../../../utils/helpers.utils";
import { Loading } from "../../../../../common/loading";
import { DATA_TYPE, MAX_LENGTH, FiveDecimalPlaces, WORKFLOW_MESSAGE, RECHARGE_INVENTORY_TYPE } from "../../../../../../constants/external-constants";
import { SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField } from "../../../../../common/custom-form/select-filter.component";
import DATEPICKER_OR from "../../../../../common/custom-form/custom-date-picker.component";
import { ConfirmationModal } from "../../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../../common/modal/notification-modal.component";
import { connect } from "react-redux";
import { TRANSLATIONS as translation } from "../../../../../../utils/constant.utils";
import CustomSearchableSelectWrapper from "../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import MappingInformation from "../../recharging-details-inventory/mapping-information/mapping-information.component";
import MrcRechargingInformation from "../../recharging-details-inventory/mrc-recharging-information/mrc-recharging-information.component";
import AdditionalInformation from "../../recharging-details-inventory/additional-information/additional-information.component";
import LocationInformation from "../../recharging-details-inventory/location-information/location-information.component";
import { RechargeInventoryDetailsActions } from "../../../../../../store/external/recharge-reducer/recharge-inventory-details.reducer/recharge-inventory-details.reducer";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../../../../utils/rbac-constants.utils";
import { validateAccessModule } from "../../../../../../utils/helpers.utils";
import CustomSearchableDropdownWrapper from "../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";

class RechargingCircuitFormView extends Component {
    constructor(props) {
        super(props);

        this.ConfirmationModal = React.createRef();

        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isSaving: false,
            originalMappingInformationData: {},
            isLoading: false
        };
    }

     toLocaleLanguage = (key, isCapitalize=true) => {
            const { locale } = this.props;
            if (locale === null || locale === '')
                return translation[translation['defaultLocaleLanguage']][key];
            
            return isCapitalize ? translation[locale][key]?.toUpperCase() : translation[locale][key];
    }

    async componentDidMount() {
        const { isCreateNew, getRechargeInventory, rechargeInventoryId, getMappingInformationList, resetRechargeInventoryDetailForm, getRechargeInventoryDropdownList,
                setRechargeInventoryType, setFormDefaultDetails} = this.props;

        this.setState({ isLoading: true });

        if (!isCreateNew && rechargeInventoryId > 0) {
            await getRechargeInventoryDropdownList(rechargeInventoryId);
            await getRechargeInventory(rechargeInventoryId).then(() => {
                this.setState({ isLoading: false });
            });

            const { data } = this.props.rechargeInventoryDetails.rechargeInventoryData;

            await this.props.getCircuitOption(1, data.CircuitCode);
            await this.props.getRechargingPersonOption(1, data.RechargePersonEmail);
            await this.props.getLocationOption(1, data.LocationCode);
            
        }
        else {
            resetRechargeInventoryDetailForm();
            await getRechargeInventoryDropdownList();

            await this.props.getCircuitOption(1);
            await this.props.getRechargingPersonOption(1);
            await this.props.getLocationOption(1);

            setFormDefaultDetails(RECHARGE_INVENTORY_TYPE["Circuit"].label);
        }
        await getMappingInformationList(rechargeInventoryId).then(() => {
            const originalMappingInformationDataCopy = JSON.parse(JSON.stringify(this.props.rechargeInventoryDetails.mappingInformationList));
            this.setState({ originalMappingInformationData: originalMappingInformationDataCopy })
        });
        setRechargeInventoryType(1);
        this.setState({
            isLoading: false
        })
    }

    componentWillUnmount() {
        const { resetRechargeInventoryDetailForm } = this.props;
        resetRechargeInventoryDetailForm();
    }

    onChangeCircuit(e) {
        const { getCircuitDetails } = this.props;
        if (e != null) {
            getCircuitDetails(e);
        }
    }

    getRechargeInventoryDetails() {
        const { getRechargeInventoryDropdownList } = this.props
        getRechargeInventoryDropdownList();
    }

    disableSaveChanges = () => {
        const { $form, rechargeInventoryDetailsForm, rechargeInventoryDetails, isCreateNew } = this.props
        const { rechargeInventory, additionalInformation, locationInformation, circuitInformation, mrcInformation } = rechargeInventoryDetailsForm;
        const { operationalStatusId } = rechargeInventory;
        const { circuitId, circuitDDI, installDate, orderTypeId } = circuitInformation;
        const { mrcRecharge, rechargeViaDummyInvoice } = mrcInformation;
        const { customerTag } = additionalInformation;
        const { locationId } = locationInformation;

        const isFieldEmpty = !operationalStatusId || !orderTypeId || !circuitId || !circuitDDI || !mrcRecharge || !rechargeViaDummyInvoice || !locationId;

        if (isFieldEmpty) {
            return true;
        }

        if (!isCreateNew) {
            const unchangedCommonInformation = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.rechargeInventory, rechargeInventory);
            const unchangedCircuitInformation = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.circuitInformation, circuitInformation);
            const unchangedAdditionalInformation = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.additionalInformation, additionalInformation);
            const unchangedLocationInformation = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.locationInformation, locationInformation);
            const unchangedMrcInformation = !$form.loadedValue ? true : isObjectEqual($form.loadedValue.mrcInformation, mrcInformation);
            const mappingInformationDetails = rechargeInventoryDetails?.mappingInformationList?.datatable?.length > 0
                ? areDataEqual(this.state.originalMappingInformationData?.datatable?.[0], rechargeInventoryDetails?.mappingInformationList?.datatable?.[0])
                : true;

            return unchangedCircuitInformation && unchangedCircuitInformation && unchangedAdditionalInformation && unchangedLocationInformation && unchangedMrcInformation && mappingInformationDetails && unchangedCommonInformation
        }
        return false; 
    }

    handleButtonConfirmation = async (rechargeInventoryId = 0, validate = 1) => {
        const { saveRechargeInventory, getRechargeInventory, getMappingInformationList } = this.props;

        this.setState({
            isSaving: true
        });

        var result = await saveRechargeInventory(rechargeInventoryId, validate);

        this.setState({
            isSaving: false
        });

        if (result.success === false) {
            if (result.isValid) {
                this.handleButtonConfirmation(rechargeInventoryId, 0);
                return;
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
                return;
            }
        }
        else {

            await getRechargeInventory(rechargeInventoryId);
            getMappingInformationList(rechargeInventoryId).then(() => {
                const originalMappingInformationDataCopy = JSON.parse(JSON.stringify(this.props.rechargeInventoryDetails.mappingInformationList));
                this.setState({ originalMappingInformationData: originalMappingInformationDataCopy })
            });
            const modalTitle = this.toLocaleLanguage("success_modal_title");

            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, modalTitle, result.message);

            return;
        }
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        const { handleCloseForm, resetRechargeInventoryDetailForm } = this.props

        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });

        if (!isShow && (saveNotif.message.toLowerCase() === this.toLocaleLanguage("recharge_circuit_created").toLowerCase())) {
            handleCloseForm();
            resetRechargeInventoryDetailForm();
        }

    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    loadUpdatedMappingInfo = (data) => {
        this.setState({
            originalMappingInformationData: data
        })
    }

    handleChangesStatus = (prop, truthValue) => {
        this.setState({
            [prop]: truthValue
        })
    }

    handleRechargingPersonSearch = (searchString) => {
        this.props.getRechargingPersonOption(1, searchString)
    }

    loadMoreRechargingPerson = (searchString) => {
        const { rechargingPersonPage } = this.props.rechargeInventoryDetails;

        this.props.getRechargingPersonOption(rechargingPersonPage + 1, searchString);
    }

    handleCircuitSearch = (searchString) => {
        this.props.getCircuitOption(1, searchString)
    }

    loadMoreCircuit = (searchString) => {
        const { circuitPage } = this.props.rechargeInventoryDetails;

        this.props.getCircuitOption(circuitPage + 1, searchString);
    }

    render() {
        const isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdRechargingInventoryRW])
        const { rechargeInventoryDetails, rechargeInventoryDetailsForm, isCreateNew, rechargeInventoryId } = this.props;
        const { rechargeInventory, circuitInformation, mrcInformation, locationInformation } = rechargeInventoryDetailsForm;
        const { operationalStatusId } = rechargeInventory;
        const { circuitId, circuitDDI, orderTypeId } = circuitInformation;
        const { mrcRecharge, rechargeViaDummyInvoice } = mrcInformation;
        const { locationId } = locationInformation;
        const requiredFields = [
            operationalStatusId,
            orderTypeId,
            circuitId,
            circuitDDI,
            mrcRecharge,
            rechargeViaDummyInvoice,
            locationId
        ];

        const hasNotification = rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem.length > 0 ?
            (rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem[0].MappingStatusID == 3
                || rechargeInventoryDetails.mappingInformationList?.datatable[0]?.dataItem[0].MappingStatusID == 4) : false;


        return (
            <>
                {
                    this.state.isLoading || this.state.isSaving ?
                        <Loading />
                        :
                        <>
                            <div className="details-field-container">

                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage('circuit_number')}`}
                                    options={rechargeInventoryDetails.circuitOptions}
                                    selected={rechargeInventoryDetails.circuitOptions.length > 0 ? rechargeInventoryDetailsForm.circuitInformation?.circuitId : null}
                                    onChange={(e) => this.onChangeCircuit(e)}
                                    requiredField={true}
                                    fieldProp='rechargeInventoryDetailsForm.circuitInformation.circuitId'
                                    tagName='subCircuitTypeID'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                    maxLength={MAX_LENGTH.limit_100}

                                    onSearchChange={this.handleCircuitSearch}
                                    onLoadMore={this.loadMoreCircuit}
                                    isLoading={rechargeInventoryDetails.isCircuitLoading}
                                    hasMore={rechargeInventoryDetails.hasMoreCircuit}
                                />
                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={`${this.toLocaleLanguage('circuit_ddi')}`}
                                    value={rechargeInventoryDetailsForm.circuitInformation.circuitDDI}
                                    fieldProp='rechargeInventoryDetailsForm.circuitInformation.circuitDDI'
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                    maxLength={MAX_LENGTH.inputText}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('circuit_type')}`}
                                    value={rechargeInventoryDetailsForm.circuitInformation.circuitTypeName}
                                    fieldProp='field'
                                    disabled={true}
                                />

                                <Select
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('operational_status')}`}
                                    options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList?.OperationalStatus}
                                    value={rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId}
                                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                    isError={false}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId'
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('recharging_inventory_type')}`}
                                    value={rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType'
                                    inputType={DATA_TYPE.decimal}
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={true}
                                />

                                <Select
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('order_type')}`}
                                    options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList.OrderType}
                                    value={rechargeInventoryDetailsForm.circuitInformation.orderTypeId}
                                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                    isError={false}
                                    fieldProp='rechargeInventoryDetailsForm.circuitInformation.orderTypeId'
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('vendor')}`}
                                    value={rechargeInventoryDetailsForm.rechargeInventory.vendorName}
                                    fieldProp='field'
                                    disabled={true}
                                />

                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('install_date')}`}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                    startDate={rechargeInventoryDetailsForm.circuitInformation.installDate}
                                    isDisable={true}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('end_user')}`}
                                    value={rechargeInventoryDetailsForm.rechargeInventory.endUserEmail}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.endUserEmail'
                                    disabled={true}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('requestor')}`}
                                    value={rechargeInventoryDetailsForm.rechargeInventory.requestorEmail}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.requestorEmail'
                                    disabled={true}
                                />

                                <CustomSearchableDropdownWrapper
                                    label={`${this.toLocaleLanguage('recharging_person')}`}
                                    options={rechargeInventoryDetails.rechargingPersonOptions}
                                    selected={rechargeInventoryDetails.rechargingPersonOptions.length > 0 ? rechargeInventoryDetailsForm.rechargeInventory.rechargePersonId : null}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargePersonId'
                                    tagName='subCircuitTypeID'
                                    optionLabelKey={{
                                        Key: 'Key',
                                        Value: 'Value'
                                    }}
                                    placeholder={`${this.toLocaleLanguage('select_placeholder', false)}`}
                                    maxLength={MAX_LENGTH.limit_100}

                                    onSearchChange={this.handleRechargingPersonSearch}
                                    onLoadMore={this.loadMoreRechargingPerson}
                                    isLoading={rechargeInventoryDetails.isEmployeeLoading}
                                    hasMore={rechargeInventoryDetails.hasMoreRechargingPerson}
                                />

                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={`${this.toLocaleLanguage('recharging_quantity')}`}
                                    value={rechargeInventoryDetailsForm.rechargeInventory.rechargeQuantity}
                                    inputType={DATA_TYPE.decimal}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.rechargeQuantity'
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                    decimalPlaces={FiveDecimalPlaces}
                                />

                                <Select
                                    className="form-select no-placeholder"
                                    label={`${this.toLocaleLanguage('hardware_category')}`}
                                    options={rechargeInventoryDetails.rechargeInventoryDetailsDropDownList.HardwareCategories}
                                    value={rechargeInventoryDetailsForm.circuitInformation.hardwareCategoryId === 0 ? 1 : rechargeInventoryDetailsForm.circuitInformation.hardwareCategoryId}
                                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                    isError={false}
                                    fieldProp='rechargeInventoryDetailsForm.circuitInformation.hardwareCategoryId'
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('service_instance_id')}`}
                                    value={rechargeInventoryDetailsForm.rechargeInventory?.serviceInstanceId}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.serviceInstanceId'
                                    placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                    maxLength={MAX_LENGTH.limit_255}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('output_record_id')}`}
                                    value={rechargeInventoryDetailsForm.rechargeInventory?.outputRecordId}
                                    fieldProp='rechargeInventoryDetailsForm.rechargeInventory.outputRecordId'
                                    inputType={DATA_TYPE.decimal}
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={true}
                                />


                            </div>
                            <div className="collapsable-items-wrapper">
                                <div className="horizontal-separator" />
                                <MappingInformation
                                    rechargeInventoryId={this.props.rechargeInventoryId}
                                    translator={this.toLocaleLanguage}
                                    handleChangesStatus={this.handleChangesStatus}
                                    loadUpdatedMappingInfo={this.loadUpdatedMappingInfo}
                                    originalMappingInformationData={this.state.originalMappingInformationData}
                                    isReadAndWrite={isReadAndWrite}
                                />
                                <MrcRechargingInformation translator={this.toLocaleLanguage} />
                                <AdditionalInformation translator={this.toLocaleLanguage} />
                                <LocationInformation translator={this.toLocaleLanguage} />
                            </div>

                            {hasNotification ?
                                <span className="pending-approval-message">{WORKFLOW_MESSAGE.refreshMappingWorkflow}</span>
                                : ''
                            }

                            <div className='save-btn-container'>
                                <ConfirmationModal
                                    ref={this.ConfirmationModal}
                                    title={this.state.saveModal.title}
                                    messageBody={this.state.saveModal.messageBody}
                                    confirmAction={this.state.saveModal.confirmAction}
                                    closeLabel={this.toLocaleLanguage("cancel_button")}
                                    confirmLabel={this.toLocaleLanguage("yes_button")}
                                    disabled={this.state.isSaving}
                                />

                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={() => this.toggleSaveNotif(false)}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                />

                                {
                                    isReadAndWrite &&
                                     <div className="tooltip-container">
                                        <div className="btn-tooltiptext">
                                            {true ?
                                                <Button className='save-details-btn btn btn-primary'
                                                    disabled={this.disableSaveChanges()}
                                                    onClick={() => this.handleButtonConfirmation(rechargeInventoryId)}
                                                    type="button">
                                                    Save Changes
                                                </Button>
                                                : null}
                                            <div className="save-tooltip-text-container">
                                                <span className="tooltip-text-save">{this.toLocaleLanguage("save_circuit_info", false)}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                               
                            </div>
                        </>
                }
            </>
        )
    }
}

export default withRouter(connect(
    state => {
        const { rechargeInventoryDetails, translation } = state;
        const { rechargeInventoryDetailsForm, forms: { rechargeInventoryDetailsForm: { $form } } } = state.form;
        return {
            ...translation,
            rechargeInventoryDetails,
            rechargeInventoryDetailsForm,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, RechargeInventoryDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(RechargingCircuitFormView));
